import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron_up",
  "use": "chevron_up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron_up\"><path d=\"M16.594 16.172L12 11.578l-4.594 4.594L6 14.766l6-6 6 6-1.406 1.406z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol